const initialState = {
  goalList: {},
  currentCycle: ""
}

const corporateGoal = (state = initialState, action) => {
  switch (action.type) {
    case "SET_CORP_GOAL_LIST":
      state.goalList = action.payload
      return state
    case "SET_CORP_GOAL_CURRENT_CYCLE":
      state = {
        ...state,
        currentCycle: action.payload
      }
      return state
    default:
      return state
  }
}

export default corporateGoal;
